import * as React from 'react';

// @ts-expect-error
import type {FieldProps} from 'redux-form';

import {FormattedNumberField} from 'shells/formatted-number-field/formatted-number-field';

type Props = FieldProps & FormattedNumberField['props'];
export function ReduxFormFormattedNumberField(props: Props) {
    const {
        input,
        meta, // eslint-disable-line @typescript-eslint/no-unused-vars
        ...selectProps
    } = props;

    // Override onChange signature, this might not work tho.
    const onChange: (arg1?: number | null | undefined) => void = input.onChange as any;

    return (
        <FormattedNumberField
            onChange={onChange}
            value={input.value} // Not sure why flow doesn't detect that this is in the spread
            {...selectProps}
        />
    );
}
